import Card from '@pretto/bricks/components/cards/Card'
import ResponsiveSSR from '@pretto/bricks/components/utility/ResponsiveSSR'

import PropTypes from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

const LABEL = {
  capacity: 'Je calcule mon budget',
  purchase: 'Je simule mon prêt',
  renegotiation: 'Je renégocie mon prêt',
}

const TAB_LABEL = {
  capacity: 'Estimer',
  purchase: 'Simuler',
  renegotiation: 'Renégocier',
}
const TAB_LABEL_EXTEND = {
  capacity: ' ma capacité',
  purchase: ' mon prêt',
  renegotiation: ' mon prêt',
}

const LIST = ['Simulation gratuite en 5 min', `100+ banques comparées`, 'Résultat instantané']

const MiniSentences = ({
  disabled,
  checks = [],
  isCheckSectionDisplayed = true,
  isInIframe,
  ctaLabel,
  onValidate,
  projectKind,
  sentences,
  tabs,
  ...props
}) => {
  const checksToDisplay = checks.length > 0 ? checks : LIST
  return (
    <Card variant="white" zDepth={2} overflowVisible {...props}>
      {tabs.length > 1 && (
        <S.Tabs>
          {tabs.map(({ isActive, kind, onClick, tabLabel }, index) => (
            <S.Tab key={index} onClick={onClick} $isActive={isActive}>
              {tabLabel || (
                <>
                  {TAB_LABEL[kind]}
                  <ResponsiveSSR min="laptop">{TAB_LABEL_EXTEND[kind]}</ResponsiveSSR>
                </>
              )}
            </S.Tab>
          ))}
        </S.Tabs>
      )}
      <S.Container>
        <S.Sentences sentences={sentences} />
        {isInIframe && (
          <S.CookiesAlert>
            En poursuivant votre navigation, vous acceptez l'utilisation de{' '}
            <S.PrivacyLink href="https://www.pretto.fr/privacy/" target="blank">
              cookies
            </S.PrivacyLink>
            .
          </S.CookiesAlert>
        )}
        <S.Button onClick={onValidate} disabled={disabled}>
          {ctaLabel || LABEL[projectKind]}
        </S.Button>
        {isCheckSectionDisplayed && (
          <S.List>
            {checksToDisplay.map(item => (
              <S.Item key={item}>
                <S.ItemIcon />
                {item}
              </S.Item>
            ))}
          </S.List>
        )}
      </S.Container>
    </Card>
  )
}

MiniSentences.defaultProps = {
  projectKind: 'purchase',
  tabs: [],
}

MiniSentences.propTypes = {
  /** List of checks. */
  checks: PropTypes.array,
  /** Whether if validation button is disabled or not. */
  disabled: PropTypes.bool,
  /** Is checks section displayed ? */
  isCheckSectionDisplayed: PropTypes.bool,
  /** Sometimes component can be use for partners in an iframe. Its content will slightly change when it is set to `true` */
  isInIframe: PropTypes.bool,
  /** Text of button. */
  ctaLabel: PropTypes.string,
  /** On validate function. */
  onValidate: PropTypes.func.isRequired,
  /** Project kind that defines the CTA. */
  projectKind: PropTypes.oneOf(Object.keys(LABEL)),
  /** `SentencesGroup` element. */
  sentences: PropTypes.array.isRequired,
  /** Tabs of component. If empty or 1 element long, there will be no tabs. */
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      isActive: PropTypes.bool,
      kind: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
    })
  ),
}
export default memo(MiniSentences)
